var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{staticClass:"page"},[_c('div',{staticClass:"page-inner",attrs:{"onboarding":"dashboard"}},[_c('h1',[_vm._v("Hello, Chris!"),_c('small',[_vm._v("Choose an option below.")])]),_c('com-menu'),_c('com-launch'),_c('com-foot')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }